<template>
    <v-dialog v-model="shows" max-width="1240" persistent>
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card height="100%">
            <v-card-title>
                <template v-if="isCreate">작품 생성</template>
                <template v-else>작품 상세</template>
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text v-if="isLoaded" class="pa-0" style="max-height: calc(90vh - 120px); overflow-y: auto">
                <v-row no-gutters>
                    <v-col cols="12" lg="4">
                        <v-card-subtitle>이미지</v-card-subtitle>
                        <v-divider />
                        <v-responsive :aspect-ratio="1 / 1">
                            <v-card-text>
                                <v-tabs-items v-if="imgSrcs.length" :value="image_selected">
                                    <v-tab-item v-for="src in imgSrcs" :key="src">
                                        <v-responsive :aspect-ratio="1 / 1">
                                            <work-imgs-overlay :imgs="imgSrcs.map((url) => ({ url }))" disableLink>
                                                <template #activator="{ attrs, on, setIndex }">
                                                    <v-img :src="src" width="100%" :aspect-ratio="1 / 1" style="cursor: pointer" v-bind="attrs" v-on="on" @click="setIndex({ url: src })" />
                                                </template>
                                            </work-imgs-overlay>
                                        </v-responsive>
                                    </v-tab-item>
                                </v-tabs-items>
                                <v-img v-else :aspect-ratio="1 / 1">
                                    <v-overlay absolute z-index="0" color="grey darken-1">이미지가 없습니다</v-overlay>
                                </v-img>
                            </v-card-text>
                        </v-responsive>
                        <v-divider />
                        <v-card-actions class="pa-4">
                            <images-input v-model="inputs.imgs" @mouseover="setImage_selected" />
                        </v-card-actions>
                    </v-col>
                    <v-col cols="12" sm="auto">
                        <v-divider v-show="!isMobile" vertical />
                        <v-divider v-show="isMobile" />
                    </v-col>
                    <v-col>
                        <v-card-subtitle>기본 정보</v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-row class="ma-n2">
                                <v-col cols="6" md="2" class="pa-2">
                                    <v-text-field label="LOT" v-model="inputs.lot" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="6" md="8" class="pa-2">
                                    <v-row class="ma-n2">
                                        <v-col class="pa-2">
                                            <autocomplete-author label="작가" v-model="inputs.author" returnObject v-bind="attrs_input" />
                                        </v-col>
                                        <v-col cols="auto" class="pa-2">
                                            <author-view @input="setAuthor">
                                                <template #activator="{ attrs, on }">
                                                    <v-tooltip right>
                                                        <template #activator="tooltip">
                                                            <v-btn outlined icon height="40" width="40" class="rounded" v-bind="{ ...attrs, ...tooltip.attrs }" v-on="{ ...on, ...tooltip.on }">
                                                                <v-icon>mdi-account-plus</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        작가추가
                                                    </v-tooltip>
                                                </template>
                                            </author-view>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="6" md="2" class="pa-2">
                                    <v-text-field label="연도" v-model="inputs.year" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="12" md="6" class="pa-2">
                                    <v-text-field label="작품명" v-model="inputs.subject" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="6" md="6" class="pa-2">
                                    <v-text-field label="재료" v-model="inputs.material" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="6" md="2" class="pa-2">
                                    <v-select
                                        label="작품타입"
                                        v-model="inputs.dimension.is3D"
                                        v-bind="attrs_input"
                                        :items="[
                                            { text: '평면', value: false },
                                            { text: '입체', value: true },
                                        ]"
                                    />
                                </v-col>
                                <template v-if="inputs.dimension.is3D">
                                    <v-col cols="6" md="5" class="pa-2">
                                        <v-row align="center" class="ma-n2">
                                            <v-col class="pa-2">
                                                <v-text-field label="세로" type="number" v-model="inputs.dimension.h" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                            <v-col cols="auto" class="pa-2">X</v-col>
                                            <v-col class="pa-2">
                                                <v-text-field label="가로" type="number" v-model="inputs.dimension.w" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6" md="5" class="pa-2">
                                        <v-row align="center" class="ma-n2">
                                            <v-col cols="auto" class="pa-2">X</v-col>
                                            <v-col class="pa-2">
                                                <v-text-field label="높이" type="number" v-model="inputs.dimension.d" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                            <v-col class="pa-2">
                                                <v-select label="단위" v-model="inputs.dimension.unit" :items="['cm', 'inch']" v-bind="attrs_input" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col cols="6" md="5" class="pa-2">
                                        <v-row align="center" class="ma-n2">
                                            <v-col class="pa-2">
                                                <v-text-field label="세로" type="number" v-model="inputs.dimension.h" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                            <v-col class="pa-2" cols="auto">X</v-col>
                                            <v-col class="pa-2">
                                                <v-text-field label="가로" type="number" v-model="inputs.dimension.w" v-bind="attrs_input" class="input--text-align-right" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6" md="5" class="pa-2">
                                        <v-row align="center" class="ma-n2">
                                            <v-col class="pa-2">
                                                <v-select label="단위" v-model="inputs.dimension.unit" :items="['cm', 'inch']" v-bind="attrs_input" />
                                            </v-col>
                                            <v-col class="pa-2">
                                                <v-text-field label="호수" v-model="inputs.dimension.code" suffix="호" v-bind="attrs_input" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </template>
                                <v-col class="pa-2" cols="6">
                                    <v-text-field label="유튜브(국문)" v-model="inputs.youtube.ko" clearable v-bind="attrs_input" />
                                </v-col>
                                <v-col class="pa-2" cols="6">
                                    <v-text-field label="유튜브(영문)" v-model="inputs.youtube.en" clearable v-bind="attrs_input" />
                                </v-col>
                                <v-col class="pa-2" cols="auto" style="width: 134px">
                                    <view-section-field label="그래프" v-bind="attrs_input">
                                        <v-card flat class="py-3" style="overflow: hidden">
                                            <image-input v-model="inputs.graph.img" :aspect-ratio="1 / 1" flat class="rounded" style="overflow: hidden" />
                                        </v-card>
                                    </view-section-field>
                                </v-col>
                                <v-col class="pa-2" cols="">
                                    <v-textarea label="그래프설명(국문)" v-model="inputs.graph.ko" v-bind="attrs_input" rows="4" />
                                </v-col>
                                <v-col class="pa-2" cols="">
                                    <v-textarea label="그래프설명(영문)" v-model="inputs.graph.en" v-bind="attrs_input" rows="4" />
                                </v-col>
                                <v-col cols="12" class="pa-2">
                                    <v-textarea label="설명" v-model="inputs.content" v-bind="attrs_input" rows="10" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-col>
                </v-row>
                <v-divider />
                <v-card-subtitle>경매 정보</v-card-subtitle>
                <v-divider />
                <v-card-text>
                    <v-row class="ma-n2">
                        <v-col cols="12" class="pa-0">
                            <div class="pa-2">
                                <v-row class="ma-n2">
                                    <v-col cols="12" md="3" class="pa-2">
                                        <work-view-mode v-model="inputs" />
                                    </v-col>
                                    <v-fade-transition leave-absolute>
                                        <v-col cols="12" md="9" class="pa-0" v-show="inputs.mode_auction == PROGRAM.value">
                                            <v-row class="ma-0">
                                                <v-col cols="12" md="4" class="pa-2">
                                                    <v-select label="프로그램" v-model="inputs.program" :items="programs" item-text="subject" return-object v-bind="attrs_input" :disabled="inputs.mode_auction !== PROGRAM.value" @input="setDuration" />
                                                </v-col>
                                                <v-col cols="12" md="4" class="pa-2">
                                                    <v-select label="그룹" v-model="inputs.group" :items="inputs?.program?.groups || []" :disabled="(inputs?.program?.groups || []).length < 1" v-bind="attrs_input" />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-fade-transition>
                                    <v-fade-transition leave-absolute>
                                        <v-col cols="12" md="3" class="pa-0" v-show="isPermanent">
                                            <div class="pa-2">
                                                <v-currency-field label="추정금액(최소)" prefix="KRW" v-model="inputs.price_sale" v-bind="attrs_input" class="input--text-align-right" />
                                            </div>
                                        </v-col>
                                    </v-fade-transition>
                                    <v-fade-transition leave-absolute>
                                        <v-col cols="12" md="" class="pa-0" v-show="hasCategory">
                                            <work-view-categories v-model="inputs" v-if="isLoaded" />
                                        </v-col>
                                    </v-fade-transition>
                                </v-row>
                            </div>
                        </v-col>
                        <v-expand-transition>
                            <v-col cols="12" class="pa-0" v-show="inputs.mode_auction == PROGRAM.value">
                                <div class="pa-2">
                                    <v-row class="ma-n2">
                                        <v-col cols="6" md="" class="pa-2">
                                            <v-select label="추정금액유형" v-model="inputs.price_estimated.text" :items="items_price_estimated_text" v-bind="attrs_input" @change="onChangePriceEstimatedText" />
                                        </v-col>
                                        <v-col cols="6" md="" class="pa-2">
                                            <v-currency-field label="추정금액(최소)" prefix="KRW" v-model="inputs.price_estimated.from" v-bind="{ ...attrs_input, disabled: !!inputs.price_estimated.text }" class="input--text-align-right" />
                                        </v-col>
                                        <v-col cols="6" md="" class="pa-2">
                                            <v-currency-field label="추정금액(최대)" prefix="KRW" v-model="inputs.price_estimated.to" v-bind="{ ...attrs_input, disabled: !!inputs.price_estimated.text }" class="input--text-align-right" />
                                        </v-col>
                                        <v-col cols="6" md="" class="pa-2">
                                            <v-currency-field label="경매시작금액" prefix="KRW" v-model="inputs.price_auction.from" v-bind="attrs_input" class="input--text-align-right" />
                                        </v-col>
                                        <v-col cols="6" md="" class="pa-2">
                                            <v-currency-field label="경매금액단위" prefix="KRW" v-model="inputs.price_auction.unit" v-bind="attrs_input" class="input--text-align-right" disabled />
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-expand-transition>
                        <v-expand-transition>
                            <v-col cols="12" class="pa-0" v-show="inputs.mode_auction == PROGRAM.value">
                                <div class="px-2 py-1">
                                    <v-row no-gutters class="ma-n2" v-show="inputs.mode_auction == PROGRAM.value">
                                        <v-col cols="12" md="6" class="px-2 py-0">
                                            <row-date-time label="경매기간-시작" v-model="inputs.duration_auction.startsAt" :attrs_input="attrs_input" />
                                        </v-col>
                                        <v-col cols="12" md="6" class="px-2 py-0">
                                            <row-date-time label="경매기간-종료" v-model="inputs.duration_auction.endsAt" :attrs_input="attrs_input" />
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-expand-transition>
                    </v-row>
                </v-card-text>
                <v-divider />
                <v-card-subtitle style="position: relative">
                    상세 정보
                    <v-tooltip right>
                        <template #activator="{ attrs, on }">
                            <v-btn text icon v-bind="attrs" v-on="on" @click="initClassifications" absolute class="mt-n2 ml-1">
                                <v-icon>mdi-cloud-download</v-icon>
                            </v-btn>
                        </template>
                        기본값 불러오기
                    </v-tooltip>
                </v-card-subtitle>
                <v-divider />
                <work-view-classifications v-model="inputs.classifications" />
            </v-card-text>
            <v-card-text v-else class="d-flex justify-center align-center" style="height: calc(90vh - 120px); overflow-y: auto">
                <v-progress-circular indeterminate size="100" width="5" />
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn large outlined @click="init">초기화</v-btn>
                <v-spacer />
                <v-btn large color="primary" @click="save"> 저장하기 </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";
import { getPriceUnit } from "@/plugins/getPriceUnit";
import { attrs_input, AUCTION_PROGRAM_HALLS, WORK_AUCTION_MODES } from "@/assets/variables";

import AuthorView from "./author-view.vue";
import ImageInput from "../dumb/image-input.vue";
import ImagesInput from "../dumb/images-input.vue";
import RowDateTime from "../dumb/row-date-time.vue";
import WorkViewMode from "./work-view-mode.vue";
import WorkImgsOverlay from "./work-imgs-overlay.vue";
import ViewSectionField from "../dumb/view-section-field.vue";
import AutocompleteAuthor from "@/components/dumb/autocomplete-author.vue";
import WorkViewCategories from "./work-view-categories.vue";
import WorkViewClassifications from "./work-view-classifications.vue";

const { NULL, PROGRAM, PRIVATE, PERMANENT } = WORK_AUCTION_MODES;

const initWork = (work = {}) => ({
    ...(work || {}),
    imgs: [...(work?.imgs || [])],
    author: work?.author || null,
    program: work?.program || null,
    category: work?.category || null,

    lot: work?.lot || null,
    year: work?.year || null,
    group: work?.group || null,
    subject: work?.subject || null,
    content: work?.content || null,
    youtube: {
        ...(work?.youtube || {}),
        ko: work?.youtube?.ko || null,
        en: work?.youtube?.en || null,
    },
    graph: {
        ...(work?.graph || {}),
        img: work?.graph?.img || null,
        ko: work?.graph?.ko || null,
        en: work?.graph?.en || null,
    },
    material: work?.material || null,
    mode_auction: work?.mode_auction || NULL.value,

    dimension: {
        ...(work?.dimension || {}),

        is3D: work?.dimension?.is3D || false,

        w: work?.dimension?.w || null,
        h: work?.dimension?.h || null,
        d: work?.dimension?.d || null,
        unit: work?.dimension?.unit || null,

        code: work?.dimension?.code || null,
    },

    classifications: [...(work?.classifications || [])].map((item) => ({ _id: Math.random(), ...item })),

    price_sale: work?.price_sale || 0,

    price_estimated: {
        ...(work?.price_estimated || {}),
        text: work?.price_estimated?.text || null,
        from: work?.price_estimated?.from || null,
        to: work?.price_estimated?.to || null,
    },

    price_auction: {
        ...(work?.price_auction || {}),
        from: work?.price_auction?.from || null,
        to: work?.price_auction?.to || null,
    },

    duration_auction: {
        ...(work?.duration_auction || {}),
        startsAt: work?.duration_auction?.startsAt || null,
        endsAt: work?.duration_auction?.endsAt || null,
    },
});

let items_price_estimated_text = [
    { text: "입력", value: null },
    { text: "별도문의", value: "별도문의" },
];

export default {
    components: {
        AuthorView,
        ImageInput,
        ImagesInput,
        RowDateTime,
        WorkViewMode,
        WorkImgsOverlay,
        ViewSectionField,
        AutocompleteAuthor,
        WorkViewCategories,
        WorkViewClassifications,
    },
    props: {
        value: { type: Object },
    },
    data: () => ({
        PROGRAM,
        attrs_input,

        shows: false,
        isLoaded: false,
        image_selected: null,
        isMobile: detect == "mobile",

        inputs: initWork(),
        programs: [],
        items_hall: Object.values(AUCTION_PROGRAM_HALLS),
        items_price_estimated_text,
    }),
    computed: {
        _work() {
            return this.value?._id;
        },
        isCreate() {
            return !this._work;
        },
        imgSrcs() {
            return this.inputs.imgs.map((file) => (file instanceof File ? URL.createObjectURL(file) : file?.url));
        },
        hasCategory() {
            return [PRIVATE.value, PERMANENT.value].includes(this.inputs.mode_auction);
        },
        isPermanent() {
            return this.inputs.mode_auction == PERMANENT.value;
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
        "inputs.imgs.length"() {
            this.image_selected = this.inputs?.imgs?.length - 1;
        },
        "inputs.price_auction.from"() {
            this.inputs.price_auction.unit = getPriceUnit(+this.inputs.price_auction.from || 0) || 0;
        },
    },
    methods: {
        async init() {
            this.isLoaded = false;
            try {
                if (this.isCreate) {
                    this.inputs = initWork();
                    await this.initClassifications();
                } else {
                    const { work } = await api.console.auction.works.get({ _id: this._work });

                    this.inputs = initWork(work);
                }
                this.programs = (await api.console.auction.programs.gets())?.programs || [];
            } finally {
                this.isLoaded = true;
            }
        },
        async initClassifications() {
            this.inputs.classifications = (await api.console.setting.get())?.setting?.workClassifications;
        },

        validate() {},

        async save() {
            this.validate();

            let { _imgs = [], imgs = [], author = {}, program = {}, category = {}, graph = {}, ...inputs } = this.inputs;

            ////////////////////////////////////////////////////////////////////
            // SET          inputs
            ////////////////////////////////////////////////////////////////////
            inputs._author = author?._id || null;
            inputs._program = program?._id || null;
            inputs._category = category?._id || null;

            delete inputs.bids;
            delete inputs._bids;

            ////////////////////////////////////////////////////////////////////
            // POST, PUT    document
            ////////////////////////////////////////////////////////////////////
            let work;
            if (this.isCreate) [work] = [(await api.console.auction.works.post(inputs))?.work];
            else [work] = [(await api.console.auction.works.put(inputs))?.work];

            ////////////////////////////////////////////////////////////////////
            // POST, DELETE resources
            ////////////////////////////////////////////////////////////////////
            for (let [index, img] of imgs.entries()) {
                if (img instanceof File) imgs[index] = (await api.console.auction.files.post({ _work: work._id, index: `imgs/${index}` }, img))?.file;
            }
            _imgs = imgs.map(({ _id }) => _id);

            if (graph.img instanceof File) graph.img = (await api.console.auction.files.post({ _work: work._id, index: `imgs/graph` }, graph.img))?.file;
            graph._img = graph.img?._id || null;

            work = (await api.console.auction.works.put({ _id: work._id, _imgs, graph }))?.work;
            alert("저장되었습니다");

            work.imgs = imgs;
            work._imgs = _imgs;
            work._imgs = _imgs;
            work.graph = graph;
            work.author = author;
            work.program = program;
            work.category = category;

            this.$emit("input", work);

            this.shows = false;
        },

        setImage_selected(file) {
            const index = this.inputs.imgs.findIndex((img) => img == file);
            this.image_selected = index;
        },

        setAuthor(author) {
            this.inputs.author = author;
        },
        setDuration({ duration: duration_auction } = {}) {
            this.inputs.duration_auction = duration_auction;
        },
        onChangePriceEstimatedText(value) {
            if (!value) return;

            // this.inputs.price_estimated.from = null;
            // this.inputs.price_estimated.to = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.input--text-align-right ::v-deep input {
    text-align: right;
}
</style>
